module.exports = __webpack_public_path__ + "img/new_index_customers1.2cbee8be.png";